import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 90 90"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.956 12.17a2.812 2.812 0 0 0-4.893 1.892 5.625 5.625 0 0 0-5.626 5.625v45a5.625 5.625 0 0 0 5.626 5.625h21.244l4.81 8.417a5.625 5.625 0 0 0 9.766 0l4.81-8.417h9.516l6.835 7.517a2.811 2.811 0 0 0 4.914-1.75 2.8 2.8 0 0 0-.752-2.033zm34.102 52.517a2.81 2.81 0 0 0-2.461 1.407l-5.625 9.843-5.625-9.843a2.81 2.81 0 0 0-2.461-1.407H14.062v-45h4.124l40.912 45zm28.505-45V65.39a2.813 2.813 0 0 1-5.626 0V19.687h-41.3a2.812 2.812 0 1 1 0-5.625h41.302a5.625 5.625 0 0 1 5.624 5.625"
    }, null, -1)
  ])))
}
export default { render: render }